import React from "react";
import "./Membership.css";

const Membership = () => {
  return (
    <div className="membership-container1">
      {/* Step 1 */}
      <div className="membership-section1">
        <div className="Video-section1">
          <iframe
            title="Step 1 Video"
            src="https://www.youtube.com/embed/your-video-id1"
            allowFullScreen
            className="membership-video1"
          ></iframe>
        </div>
        <div className="details-section1">
          <h2>Step 1: Register for an Account</h2>
          <p>
            To participate in an auction, you first need to register for an account. It's quick, easy, and free!
          </p>
          <h4>How to Register:</h4>
          <ul>
            <li>
              Visit the Auto Motor Auctions website at{" "}
              <a href="https://www.automotorauctions.com" target="_blank" rel="noopener noreferrer">
                www.AutoMotorAuctions.com
              </a>.
            </li>
            <li>Click on the “Sign Up” button at the top right of the homepage.</li>
            <li>Provide your personal information, including your name, address, email, and phone number.</li>
            <li>Set up a username and password for your account.</li>
            <li>Verify your email.</li>
            <li>Agree to Terms of Use and other checkboxes.</li>
          </ul>
          <p>
            Once registered, you’ll have access to our inventory of over 300k vehicles, all available vehicles, and upcoming auctions.
          </p>
        </div>
      </div>

      {/* Step 2 */}
      <div className="membership-section1 reverse">
        <div className="details-section1">
          <h2>Step 2: Browse Available Auctions</h2>
          <p>
            Once you’ve created your account, you can start exploring vehicles available for auction. Auto Motor Auctions offers a wide range of vehicles, including cars, trucks, motorcycles, RVs, and more.
          </p>
          <h4>How to Browse:</h4>
          <ul>
            <li>Use the search bar to filter vehicles by make, model, year, condition (e.g., salvage, clean title), and location.</li>
            <li>You can also sort listings by auction date, price, or vehicle type.</li>
            <li>For a more detailed view, click on any vehicle listing to see additional information, including photos, damage reports, and the vehicle’s history.</li>
          </ul>
          <h4>Key Features to Explore:</h4>
          <ul>
            <li>Vehicle Listings: Detailed descriptions, photos, and VIN numbers.</li>
            <li>Auction Details: Start time, bidding duration, and current bid.</li>
            <li>Auction History: View past sale prices and trends.</li>
            <li>Use the search filters to narrow down your options.</li>
          </ul>
        </div>
        <div className="Video-section1">
          <iframe
            title="Step 2 Video"
            src="https://www.youtube.com/embed/your-video-id2"
            allowFullScreen
            className="membership-video1"
          ></iframe>
        </div>
      </div>

      {/* Step 3 */}
      <div className="membership-section1">
        <div className="Video-section1">
          <iframe
            title="Step 3 Video"
            src="https://www.youtube.com/embed/your-video-id3"
            allowFullScreen
            className="membership-video1"
          ></iframe>
        </div>
        <div className="details-section1">
          <h2>Step 3: Review the Vehicle Details</h2>
          <p>
            Each vehicle listed in our auctions includes detailed information, including:
          </p>
          <ul>
            <li>Condition Report: A thorough assessment of the vehicle’s condition.</li>
            <li>Auction History: Past auction results and pricing trends.</li>
            <li>VIN Report: Vehicle history, including accidents, ownership, and more.</li>
            <li>Photos: High-resolution images to give you a complete view of the vehicle.</li>
          </ul>
          <p>
            We strongly encourage you to review this information carefully before proceeding with your bid.
          </p>
        </div>
      </div>

      {/* Step 4 */}
      <div className="membership-section1 reverse">
        <div className="details-section1">
          <h2>Step 4: Make a Deposit and Place Your Bid</h2>
          <p>
            Once you've found the vehicle you're interested in, it's time to place your bid!
          </p>
          <h4>How to Bid:</h4>
          <ul>
            <li>Log into your Account.</li>
            <li>
              Make a deposit of $600 for cars under $6000, or 10% of the purchase price for cars over $6000.
            </li>
            <li>Navigate to the vehicle’s listing page and enter your maximum bid amount.</li>
            <li>Click "Place Bid."</li>
          </ul>
          <p>
            Our Support Team will contact you to continue with the auction. You can also click “Attend Live Auction” to participate on auction day.
          </p>
        </div>
        <div className="Video-section1">
          <iframe
            title="Step 4 Video"
            src="https://www.youtube.com/embed/your-video-id4"
            allowFullScreen
            className="membership-video1"
          ></iframe>
        </div>
      </div>

      {/* Step 5 */}
      <div className="membership-section1">
        <div className="Video-section1">
          <iframe
            title="Step 5 Video"
            src="https://www.youtube.com/embed/your-video-id5"
            allowFullScreen
            className="membership-video1"
          ></iframe>
        </div>
        <div className="details-section1">
          <h2>Step 5: Winning the Auction</h2>
          <p>
            If you are the highest bidder when the auction ends, you will win the auction, provided your bid meets the seller’s reserve price.
          </p>
          <h4>Next Steps:</h4>
          <ul>
            <li>Payment: You’ll receive a notification with payment instructions.</li>
            <li>Pay within the required timeframe (usually 3 business days).</li>
            <li>
              Be aware of auction charges, taxes, and fees in addition to the vehicle price.
            </li>
          </ul>
        </div>
      </div>

      {/* Step 6 */}
      <div className="membership-section1 reverse">
        <div className="details-section1">
          <h2>Step 6: Shipping or Delivery</h2>
          <p>
            Once your payment is received, you can arrange to pick up your vehicle or have it shipped.
          </p>
          <h4>Things to Note:</h4>
          <ul>
            <li>We are not affiliated with shipping companies but can help with arrangements.</li>
            <li>Request an estimate for shipping costs.</li>
            <li>Vehicles whose shipping invoices remain unpaid after 21 days may be considered abandoned.</li>
          </ul>
        </div>
        <div className="Video-section1">
          <iframe
            title="Step 6 Video"
            src="https://www.youtube.com/embed/your-video-id6"
            allowFullScreen
            className="membership-video1"
          ></iframe>
        </div>
      </div>

      {/* Step 7 */}
      <div className="membership-section1">
        <div className="Video-section1">
          <iframe
            title="Step 7 Video"
            src="https://www.youtube.com/embed/your-video-id7"
            allowFullScreen
            className="membership-video1"
          ></iframe>
        </div>
        <div className="details-section1">
          <h2>Step 7: Enjoy Your New Ride!</h2>
          <p>
            After receiving your vehicle, it’s yours to enjoy! Be sure to review the vehicle’s documentation and perform any necessary maintenance before hitting the road.
          </p>
          <h4>Helpful Tips:</h4>
          <ul>
            <li>Set a budget and stick to it.</li>
            <li>Inspect the vehicle thoroughly before bidding.</li>
            <li>Understand the vehicle’s condition and any additional fees involved.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Membership;
